// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"76f67973","703":"99d35946","787":"c4fc5903"}[chunkId] + ".chunk.js";
};